module.exports = __webpack_public_path__ + "img/SAC_Option4_woman.1575f77f.png";